module.exports = __webpack_public_path__ + "static/media/ic_post_invoices.20a52ffb.svg";